import PropTypes from 'prop-types'
import { useUserContext } from '../../auth/UserProvider'

import ShippingsOverviewView from './View'

// NOTE Esto es un componente proxy que deberá ir adquiriendo progresivamente lógica que actualmente está en el View
const ShippingsOverview = props => {
  const { statusList } = useUserContext()

  return <ShippingsOverviewView {...props} statusList={statusList} />
}

ShippingsOverview.propTypes = {
  ...ShippingsOverviewView.propTypes,
  statusList: PropTypes.any,
}

export default ShippingsOverview
